@if (mappedItem && lotBuildPermissions?.$resolved) {
    <cb-document
        [edit]="true"
        [entity]="mappedItem"
        [permissions]="lotBuildPermissions?.getDocumentPermissions()"
        [prefixColumns]="extraCol"
        [systemArea]="systemArea"
        [hideDeletedToggle]="false"
        [includeDeleted]="true"
        [dtoDefinition]="dtoDefinition"
        [enableCheckbox]="true"
        [allowReviewAtUpload]="true"
    >
    </cb-document>
}
